<template>
  <div id="reorder-diff-container">
    <div>
      <div class="reorder-diff" id="reorder-diff-fixed" :style="{visibility: showFixed ? 'visible' : 'hidden'}">
        <div class="container">
          <div><img src="../../assets/imgs/order-detail/cue.png" alt="">顾客申请修改赴馆时间</div>
          <button type="button" @click="reOrder()">重新预约缴费</button>
        </div>
      </div>
      <div class="reorder-diff" :style="{visibility: !showFixed ? 'visible' : 'hidden'}">
        <div class="container">
          <div><img src="../../assets/imgs/order-detail/cue.png" alt="">顾客申请修改赴馆时间</div>
          <button type="button" @click="reOrder()">重新预约缴费</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showFixed: true,
      footer: null,
      documentElement: null,
    };
  },
  components: {},
  computed: {},
  methods: {
    reOrder() {
      this.$emit('reOrder');
    },
    scrollEvent() {
      const self = this;
      const scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      // 卷去高度大于footer元素减去页面可视高度，即footer元素出现在页面可视区域，
      // 展示非固定的浮层
      self.showFixed =
        Number(scrollTop) <
        Number(self.footer.offsetTop - self.documentElement.clientHeight);
    },
  },
  mounted() {
    this.footer = document.getElementById('footer');
    this.documentElement = document.documentElement;
    window.addEventListener('scroll', this.scrollEvent);
  },
  destroyed() {
    window.removeEventListener('scroll', this.scrollEvent);
  },
};
</script>

<style lang="less" scoped>
#reorder-diff-container {
  #reorder-diff-fixed {
    position: fixed;
    bottom: 0;
  }
  .reorder-diff {
    font-size: 16px;
    width: 100%;
    height: 80px;
    background-color: rgba(94, 155, 225, 0.9);
    z-index: 6;
    .container {
      position: relative;
      width: 920px;
      margin: auto;
      div {
        color: #ffffff;
        font-size: 16px;
        height: 100%;
        line-height: 80px;
        float: left;
        position: relative;
        padding-left: 40px;
        img {
          width: 30px;
          height: 30px;
          position: absolute;
          top: calc(~'50% - 15px');
          left: 0;
        }
      }
      button {
        width: 200px;
        height: 44px;
        position: absolute;
        top: calc(~'50% - 22px');
        background-color: #ffffff;
        border-radius: 22px;
        color: #5e9be1;
        border: 0;
        right: 0;
        &:focus {
          outline: -webkit-focus-ring-color auto 0px;
        }
      }
    }
  }
}
</style>





// WEBPACK FOOTER //
// src/components/order-detail/reorder-diff.vue